import { render, staticRenderFns } from "./ProductAddOns.vue?vue&type=template&id=3102fe88&"
import script from "./ProductAddOns.vue?vue&type=script&lang=js&"
export * from "./ProductAddOns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports